export function preloadImages({
  urls,
  allImagesLoadedCallback,
  progressCallback,
}) {
  var loadedCounter = 0;
  var toBeLoadedNumber = urls.length;
  urls.forEach(function (url) {
    preloadImage(url, function () {
      loadedCounter++;
      if (typeof progressCallback === "function")
        progressCallback(loadedCounter, (toBeLoadedNumber));
      if (loadedCounter == toBeLoadedNumber) {
        if (typeof allImagesLoadedCallback === "function") {
          allImagesLoadedCallback();
        }
      }
    });
  });
  function preloadImage(url, anImageLoadedCallback) {
    var img = new Image();
    img.onload = anImageLoadedCallback;
    img.src = url;
  }
}
